/* eslint-disable @typescript-eslint/no-explicit-any */
import { entitlementsApi } from "../../lib/api";
export const getEntitlementsData = async () => {
    const response = await entitlementsApi.get(`/entitlements/v1/permissions`);
    return response.data; // return the data if the API call succeeds
};
